import React, { useRef, useCallback, useEffect } from 'react';

import MessageInfo from './message-info';
import MessageBase from './message-base';
import EventBase from '../message-event/event-base';
import MessageSensitive from './message-sensitive';

const Message = props => {
  const {
    data = {},
    clickFailIcon,
    handleAddClue,
    handleImageStream,
    onLoad,
    handleReEdit,
    handleWithdrawMessage,
    handleTranslateMessage,
    handleRemindMessage,
    handleClickRemindMessage,
    highlightFlag,
    handleSpeechToTxt,
    handleGptSummary,
    handleIntelligentRecommend
  } = props;

  const { contentType, action, isEdit } = data;
  const isEvent = contentType === 'event';
  const isFakeSensitiveMessage = action === 'agent_send_sensitive_words';
  const messageRef = useRef(null);

  const highlightMessage = useCallback(() => {
    if (messageRef && messageRef.current) {
      const settings = {
        duration: 3000
      };
      const animateFrames = [
        { background: 'transparent', offset: 0 },
        { background: '#e1e5f0', offset: 0.5 },
        { background: 'transparent', offset: 1 }
      ];
      messageRef.current.animate(animateFrames, {
        ...settings,
        id: 'messageHightLight'
      });
    }
  }, [messageRef]);

  useEffect(() => {
    if (highlightFlag) {
      highlightMessage();
    }
  }, [highlightFlag]);

  useEffect(() => {
    if (isFakeSensitiveMessage && isEdit !== undefined) {
      onLoad();
    }
  }, [isFakeSensitiveMessage]);

  return (
    <div ref={messageRef}>
      {isFakeSensitiveMessage ? (
        <>
          <MessageSensitive data={data} onLoad={onLoad} />
          <EventBase data={data} handleReEdit={handleReEdit} />
        </>
      ) : isEvent ? (
        <EventBase data={data} handleReEdit={handleReEdit} handleGptSummary={handleGptSummary} />
      ) : (
        <MessageInfo
          data={data}
          clickFailIcon={clickFailIcon}
          handleWithdrawMessage={handleWithdrawMessage}
          handleRemindMessage={handleRemindMessage}
          handleTranslateMessage={handleTranslateMessage}
          handleSpeechToTxt={handleSpeechToTxt}
          handleIntelligentRecommend={handleIntelligentRecommend}
          render={val => {
            return (
              <MessageBase
                data={val}
                handleAddClue={handleAddClue}
                handleImageStream={handleImageStream}
                handleClickRemindMessage={handleClickRemindMessage}
                onLoad={onLoad}
              />
            );
          }}
        />
      )}
    </div>
  );
};

export default Message;
